export var scrollIntoView = function (element) {
    if (!element) {
        return;
    }
    if (element.scrollIntoViewIfNeeded) {
        element.scrollIntoViewIfNeeded();
    }
    else {
        var boundingBox = element.getBoundingClientRect();
        var isElementInViewport = boundingBox.top >= 0 &&
            boundingBox.left >= 0 &&
            boundingBox.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
            boundingBox.right <=
                (window.innerWidth || document.documentElement.clientWidth);
        if (!isElementInViewport) {
            element.scrollIntoView();
        }
    }
};
